// Copyright (c) 2016 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import {translate} from '../../../shared/services/translation-service';

export const getPartTypesCollection = () => [
    new KeyValuePair({
        key: 'lifeTime',
        value: translate('LIFETIME')
    }),
    new KeyValuePair({
        key: 'merchandizeItem',
        value: translate('MERCHANDISE')
    })
];



// WEBPACK FOOTER //
// ./src/claim/parts/services/get-part-types.js